<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="OutOfOfficePoliciesForm" (ngSubmit)="Validate(OutOfOfficePoliciesForm)"
        #OutOfOfficePoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Out of Office Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="OutofOfficeRuleTitle" class="form-label text-label-dark">Policy Name
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="OutofOfficeRuleTitle" name="OutofOfficeRuleTitle"
                                [(ngModel)]="OutOfOfficeDetail.OutOfOfficeRuleName"
                                #OutofOfficeRuleTitle="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsOutofOfficeForFutureDate" class="form-label text-label-dark">Out of Office
                                allow for
                                future date :</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.OutofPolicyPolicy.OutofOfficeallowforfuturedate"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="IsOutofOfficeForFutureDate"
                                        [(ngModel)]="OutOfOfficeDetail.IsOutOfOfficeForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="IsOutofOfficeForFutureDate"
                                        [(ngModel)]="OutOfOfficeDetail.IsOutOfOfficeForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Out of Office request can be raised</label>
                        </div>
                        <div class="col-md-2" style="width: 115px;">
                            <input type="text" maxlength="3" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light"
                                [ngClass]="{'ng-invalid': common.parseFloat(OutOfOfficeDetail.TillDateRequestForOutOfOffice) > 365}"
                                placeholder="Ex. 01" id="TillDateRequestForOutOfOffice"
                                name="TillDateRequestForOutOfoffice"
                                [(ngModel)]="OutOfOfficeDetail.TillDateRequestForOutOfOffice"
                                #TillDateRequestForOutOfoffice="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter max 365 days!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Day's from the date to be Out of Office</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.OutofPolicyPolicy.OutofOfficerequestcanberaised"></i>
                        </div>
                    </div>

                     <div class="row mb-3">
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Allow for</label>
                        </div>
                        <div class="col-md-2" style="width: 115px;">
                             
                            <input type="text" maxlength="5" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light" placeholder="Ex. 01"
                                id="AllowOutOfOfficeForDays" name="AllowofuofofficeForDays"
                                [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeForDays"
                                #AllowofuofofficeForDays="ngModel">
                        </div>
                        <div class="col-md-auto align-self-top">
                           
                            <label class="form-label text-label-dark">time(s)</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="AllowOutOfOfficeFor"
                                placeholder="" title="AllowOutOfOfficeFor"
                                name="AllowoutofofficeFor"
                                [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeFor"
                                #AllowoutofofficeFor="ngModel" required>
                                <option disabled [value]=null>--Select Period--</option>
                                <option *ngFor="let PeriodType of common.PeriodTypes" [value]=PeriodType.Value>
                                    {{PeriodType.Name}}</option>
                            </select>
                            <div class="invalid-feedback">
                                Please select Out of Office for!
                            </div>
                        </div>
                        <div class="col-md-auto"><i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.OutofPolicyPolicy.Allowfor"></i></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowOutOfOfficeForSameDays" class="form-label text-label-dark">Allow
                                Out of Office for same
                                date :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowOutOfOfficeForSameDays"
                                        [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.OutofPolicyPolicy.AllowOutofOfficeforsamedateYES"></i>
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowOutOfOfficeForSameDays"
                                        [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.OutofPolicyPolicy.AllowOutofOfficeforsamedateNO"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowOutOfOfficeForPreviousMonth" class="form-label text-label-dark">Allow
                                Out of Office for previous
                                month :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowOutOfOfficeForPreviousMonth"
                                        [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.OutofPolicyPolicy.AllowOutofOfficeforpreviousdateYES"></i>
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowOutOfOfficeForPreviousMonth"
                                        [(ngModel)]="OutOfOfficeDetail.AllowOutOfOfficeForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.OutofPolicyPolicy.AllowOutofOfficeforpreviousdateNO"></i>
                                </label>
                            </div>
                        </div>
                    </div> 
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowOutOfOfficeForAttachment" class="form-label text-label-dark"> 
                              Is Attachment Mandatory :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowOutOfOfficeForAttachment"
                                        [(ngModel)]="OutOfOfficeDetail.IsAttachmentMandatory"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                    <!-- <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforpreviousdateYES"></i> -->
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowOutOfOfficeForAttachment"
                                        [(ngModel)]="OutOfOfficeDetail.IsAttachmentMandatory"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                    <!-- <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforpreviousdateNO"></i> -->
                                </label>
                            </div>
                        </div>
                    </div> 
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId == 0) || (this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId > 0 && common.ToLowerCase(OutOfOfficeDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="OutOfOfficeDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="OutOfOfficeDetail.ESS_OutOfOfficeRuleId > 0"
                                        (change)="GetApplicability()" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId == 0) || (this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId > 0 && common.ToLowerCase(OutOfOfficeDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="OutOfOfficeDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="OutOfOfficeDetail.ESS_OutOfOfficeRuleId > 0"
                                        (change)="GetApplicability()" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center me-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Default Policy
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="DefaultRule"
                                        [(ngModel)]="OutOfOfficeDetail.DefaultRule"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="DefaultRule"
                                        [(ngModel)]="OutOfOfficeDetail.DefaultRule"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="OutOfOfficeDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && OutOfOfficeDetail.DefaultRule">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && OutOfOfficeDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId == 0) || (this.common.PageRight.IsEdit && this.OutOfOfficeDetail.ESS_OutOfOfficeRuleId > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>